import { ROUTE_KEYS } from './routeKeys';

const ROUTE_PATHS: Record<(typeof ROUTE_KEYS)[number], { path: string }> = {
    DROIT_IMAGE_FORM: { path: '/droit-image' },
    DROIT_IMAGE_ENTRIES: { path: '/droit-image-entries' },
    DROIT_IMAGE_PREVIEW: { path: '/droit-image/:droitImageId/preview' },
    FICHE_RENSEIGNEMENT: { path: '/fiche-renseignement' },
    FICHE_RENSEIGNEMENT_ENTRIES: { path: '/fiche-renseignement-entries' },
    FICHE_INSCRIPTION: { path: '/formulaire-inscription' },
    FICHE_INSCRIPTION_ENTRIES: { path: '/formulaire-inscription-entries' },
    FICHE_INSCRIPTION_PREVIEW: { path: '/formulaire-inscription/:ficheInscriptionId/preview' },
    FORMATION_CONTINUE: { path: '/formation-continue' },
    FORMATION_INITIALE: { path: '/formation-initiale' },
    FORMATION_ENTRY: { path: '/formation-entries/:kind/:id' },
    FORMATION_ENTRIES: { path: '/formation-entries/:kind' },
    INSCRIPTION_SUCCESS: { path: '/inscription-success' },
    FORMATION_INITIALE_SUCCESS: { path: '/formation-initiale-success' },
    FICHE_RENSEIGNEMENT_SUCCESS: { path: '/fiche-renseignement-success' },
    FICHE_RENSEIGNEMENT_PREVIEW: { path: '/fiche-renseignement/:ficheRenseignementId/preview' },
};

export { ROUTE_PATHS };
